/*eslint-disable */
import React, { Component } from "react";
import ActionButton from "./actionButton";
import TitleBar from "../titleBar/title_bar";
import { AgGridReact } from "ag-grid-react";
import { AllModules } from "ag-grid-enterprise";
import { Header, Segment } from "semantic-ui-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import "ag-grid-enterprise";
import { LicenseManager } from "ag-grid-enterprise";
import LoadingPlaceholder from "../placeholderComponent/loadingPlaceholder";
import ReadAxios from "../axiosComponent/read";
import { RowNode } from "ag-grid-community";
import DetailsModal from "./detailsModal";
LicenseManager.setLicenseKey(
  "Elixia_Tech_Solutions_Ltd_MultiApp_1Devs16_March_2019__MTU1MjY5NDQwMDAwMA==c4c29e5702e62789dbdb799433c73545"
);
class AsyncAgGridTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modules: AllModules,
      defaultColDef: {
        flex: 1,
        minWidth: 300,
        filter: true,

      },
      sideBar: {
        toolPanels: [
          {
            id: "columns",
            labelDefault: "Columns",
            labelKey: "columns",
            iconKey: "columns",
            toolPanel: "agColumnsToolPanel",
          },
          {
            id: "filters",
            labelDefault: "Filters",
            labelKey: "filters",
            iconKey: "filter",
            toolPanel: "agFiltersToolPanel",
          },
        ],
        defaultToolPanel: "",
      },
      isLoading: true,
      searchValue: "",
      rowData: [],
      pageChangeCallback: false,
      currentPageNumber: -1,
    };
  }

  handleChange = (e) => {
    this.setState({ searchValue: e.target.value });
  };

  getParams() {
    return {
      columnGroups: true,
      fileName: this.props.titleBarTitle,
    };
  }

  onBtnExportDataAsExcel = () => {
    var params = this.getParams();
    this.gridApi.exportDataAsExcel(params);
  };

  onGridReady = (prams) => {
    this.gridApi = prams.api;
    this.gridColumnApi = prams.columnApi;
    this.setState({
      isLoading: this.props.isLoading,
    });
    // prams.api.sizeColumnsToFit();
  };

  importDataGrid = () => {
    console.log("import the data grid");
  };

  exportDataGrid = () => {
    let keys = [];
    this.props.columnDefs.forEach((element) => {
      element.field !== "edit" && keys.push(element.headerName);
    });
    // console.log(keys);
    let param = {
      fileName: this.props.titleBarTitle,
    };
    this.gridApi.exportDataAsExcel(param);
  };

  paginationCallback = async (event) => {
    if (
      this.state.currentPageNumber != this.props.currentPageNumber ||
      event.api.paginationProxy.currentPage != this.props.currentPageNumber
    ) {
      this.setState(
        {
          pageChangeCallback: true,
          currentPageNumber: this.props.currentPageNumber,
        },
        () => this.props.OnpaginationChangeCallback(event)
      );
    }
  };

  componentDidMount() {
    console.log("ag grid component did mount");
    this.setState({ rowData: this.props.rowData });
  }

  componentWillReceiveProps(nextProps) {
    this.setState(
      { rowData: nextProps.rowData },
      () => this.gridApi && this.gridApi.setRowData(this.state.rowData)
    );
  }

  filterChanged = (e) => {
    if (this.gridApi.getDisplayedRowCount() === 0) {
      this.gridApi.showNoRowsOverlay();
    } else {
      this.gridApi.hideOverlay();
    }
  };

  onSelectionChanged = () => {
    var selectedRow = this.gridApi.getSelectedRows();
    this.props.redirectToShipmentDetail &&
      this.props.redirectToShipmentDetail(selectedRow);
  };

  render() {
    const frameworkComponents = {
      actionRenderer: ActionButton,
      detailRenderer: DetailsModal,
    };

    if (this.props.isLoading === true) {
      return (
        <React.Fragment>
          {this.props.titleBarTitle != "Orders" ? (
            <TitleBar
              title={this.props.titleBarTitle}
              LinkName={this.props.titleBarLink}
              handleSearch={this.handleChange}
              importDataGrid={this.importDataGrid}
              exportDataGrid={this.exportDataGrid}
              exportHidden={this.props.exportHidden}
              radioToggle={this.props.radioToggle}
              toggleView={this.props.toggleView}
              toggle={this.props.toggle}
            />
          ) : (
            null
          )}

          <LoadingPlaceholder />
        </React.Fragment>
      );
    } else if (!this.props.rowData || this.props.rowData.length === 0) {
      return (
        <React.Fragment>
          {this.props.titleBarTitle != "Orders" ? (
            <TitleBar
              title={this.props.titleBarTitle}
              LinkName={this.props.titleBarLink}
              handleSearch={this.handleChange}
              importDataGrid={this.importDataGrid}
              exportDataGrid={this.exportDataGrid}
              exportHidden={this.props.exportHidden}
              radioToggle={this.props.radioToggle}
              toggleView={this.props.toggleView}
              toggle={this.props.toggle}
            />
          ) :
            (
              null
            )}
          <Segment className="m-2">
            <center>
              {" "}
              <Header>NO Record(s) Found</Header>
            </center>
          </Segment>
        </React.Fragment>
      );
    } else {
      return (
        <>
          {this.props.titleBarTitle != "Orders" ? (
            <TitleBar
              title={this.props.titleBarTitle}
              LinkName={this.props.titleBarLink}
              handleSearch={this.handleChange}
              importDataGrid={this.importDataGrid}
              exportDataGrid={this.exportDataGrid}
              exportHidden={this.props.exportHidden}
              radioToggle={this.props.radioToggle}
              toggleView={this.props.toggleView}
              toggle={this.props.toggle}
            />) :
            (
              null
            )}
          <div className="ag-theme-material agOver">
            <AgGridReact
              domLayout="autoHeight"
              modules={this.state.modules}
              sideBar={this.state.sideBar}
              rowGroupPanelShow={"always"}
              quickFilterText={this.state.searchValue}
              suppressAutoSize={true}
              columnDefs={this.props.columnDefs}
              defaultColDef={this.state.defaultColDef}
              frameworkComponents={frameworkComponents}
              rowSelection="multiple"
              rowData={this.props.rowData}
              pagination={true}
              paginationPageSize={this.props.pegination || 30}
              onGridReady={this.onGridReady}
              baseURL={this.props.baseURL}
              completeURL={this.props.completeURL}
              keyIndex={this.props.keyIndex}
              onCellDoubleClicked={this.props.cellDoubleClicked}
              onEdit={this.props.onEdit}
              onDelete={this.props.onDelete}
              onPaginationChanged={this.paginationCallback}
              noRowsOverlayComponent={() => this.state.noRowsOverlayComponent()}
              noRowsOverlayComponentParams={
                this.state.noRowsOverlayComponentParams
              }
              onFilterChanged={this.filterChanged}
              onSelectionChanged={this.onSelectionChanged}
              hideRowEdit={this.props.hideRowEdit}
            />
          </div>
        </>
      );
    }
  }
}

export default AsyncAgGridTable;
